//react
import React from 'react';

//redux
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { LessonCreated } from 'redux/actions';

//firebase
import { db, storage } from 'assets/firebase';

//styles
import withStyles from "@material-ui/core/styles/withStyles";
import modalStyle from "assets/jss/material-kit-react/modalStyle.jsx";

//core
import Slide from "@material-ui/core/Slide";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import Switch from "@material-ui/core/Switch";
import FormControlLabel from "@material-ui/core/FormControlLabel";

//components
import CustomTabs from "components/CustomTabs/CustomTabs.jsx";
import CustomSelect from "components/Select/Select.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";
import PhotoCard from "components/PhotoCard/PhotoCard.jsx";
import AttachmentEditor from "components/AttachmentEditor/AttachmentEditor.jsx";

// @material-ui/icons
import Edit from "@material-ui/icons/Edit";
import Location from "@material-ui/icons/LocationOn";
import Photos from "@material-ui/icons/AddAPhotoOutlined";
import Notes from "@material-ui/icons/Notes";
import Attachment from "@material-ui/icons/AttachFile";
import Delete from "@material-ui/icons/DeleteOutline";
import Book from "@material-ui/icons/Book";

//fileUploader
import FileUploader from 'react-firebase-file-uploader';

//draft html editor
import ContentEditor from "components/ContentEditor/ContentEditor.jsx";

//google Analytics
import ReactGA from 'react-ga';
ReactGA.initialize('UA-127392840-1');

//unique id generator
const uuidv4 = require('uuid/v4');

function Transition(props) {
  return <Slide direction="down" {...props} />;
}

function compareSortIndex(a,b) {

  var x = Number(a.SortIndex);
  var y = Number(b.SortIndex);

  return x-y;
}
  
class LessonEditor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      courses: []
    };

    var lesson = props.lesson;
    if(!lesson.Course)
      lesson.Course = "";
    for(var i = 0; i < lesson.Attachments.length; i++)
      if(!lesson.Attachments[i].SortIndex)
        lesson.Attachments[i].SortIndex = 0;
    lesson.Attachments.sort(compareSortIndex);
    this.state.lesson = lesson;
      
    this.saveLesson = this.saveLesson.bind(this);
    this.updateLesson = this.updateLesson.bind(this);

    this.deletePhoto = this.deletePhoto.bind(this);
    this.updatePhoto = this.updatePhoto.bind(this);
    this.makeCoverPhoto = this.makeCoverPhoto.bind(this);
    this.makeThumbPhoto = this.makeThumbPhoto.bind(this);

    this.deleteAttachment = this.deleteAttachment.bind(this);
    this.updateAttachment = this.updateAttachment.bind(this);
  }

  componentWillMount() {
      var courses = []; 
      for(var i = 0; i < this.props.courses.length; i++) {
          courses.push({key:this.props.courses[i].id, label:this.props.courses[i].Name});
      }
      this.setState({courses: courses});
  }

  handleClickOpen(modal) {
    var x = [];
    x[modal] = true;
    this.setState(x);

    if(this.state.lesson.Course === "") {
      this.updateLesson("Course",this.props.course);
    }
  }

  handleClose(modal) {
    var x = [];
    x[modal] = false;
    this.setState(x);
  }

  updateLesson(property, value) {
    var lesson = this.state.lesson;
    lesson[property] = value;
    this.setState({lesson: lesson});
  }

  addPhoto(url) {

    var lesson = this.state.lesson;
    if(!lesson.Photos) {
      lesson.Photos = [];
    }

    var photo = { ID: uuidv4(), Name: "New Photo", Description: "description", URL: url, Attribution:"", License:"", isCover: false, isThumb: false};

    lesson.Photos.push(photo);
    this.setState({lesson:lesson});
  }

  updatePhoto(photo) {
    var lesson = this.state.lesson;
    
    for(var i = 0; i < lesson.Photos.length; i++) {
      if(lesson.Photos[i].ID === photo.ID) {
        lesson.Photos[i] = photo;
        break;
      }
    }
    this.setState({lesson:lesson});
  }

  deletePhoto(photo) {
    var lesson = this.state.lesson;

    for(var i = lesson.Photos.length - 1; i > -1; i--) {
      if(lesson.Photos[i].ID === photo.ID) {
        lesson.Photos.splice(i,1);
        break;
      }
    }

    this.setState({lesson:lesson});
  }

  makeCoverPhoto(photo) {
    var lesson = this.state.lesson;
    
    for(var i = 0; i < lesson.Photos.length; i++) {
      if(lesson.Photos[i].ID === photo.ID) {
        lesson.Photos[i].isCover = true;
      } else {
        lesson.Photos[i].isCover = false;
      }
    }
  }

  makeThumbPhoto(photo) {
    var lesson = this.state.lesson;
    
    for(var i = 0; i < lesson.Photos.length; i++) {
      if(lesson.Photos[i].ID === photo.ID) {
        lesson.Photos[i].isThumb = true;
      } else {
        lesson.Photos[i].isThumb = false;
      }
    }
  }

  saveLesson() {
  
    var lesson = this.state.lesson;
    lesson.modified = Math.round((new Date()).getTime());
    db.updateLesson(lesson.id, lesson).then(doc => {
      
      if(!lesson.id) { // i.e. if it's a new lesson
        //this.updateLesson("id",doc.id);
        lesson.id = doc.id;
        this.props.onLessonCreated(lesson);

        // reset for next new lesson
        this.setState({lesson: {
          Name: "",
          Description: "",
          Attachments:[],
          Photos: [],
          Quarter: 1,
          Week: 1,
          Video: "",
          Course: this.props.course,
          orgId: this.props.org.id
        }}); 

        ReactGA.event({
          category: 'Lesson',
          action: 'Created a New Lesson'
        });
      } else { // i.e. an existing lesson

        ReactGA.event({
          category: 'Lesson',
          action: 'Updated a Lesson'
        });
      }

      this.props.onChange();
    });
  }
        
  // photos
  photoUploadStart = () => this.setState({isUploading: true, progress: 0});
  photoUploadProgress = (progress) => this.setState({progress});
  photoUploadError = (error) => {
      this.setState({isUploading: false});
      console.error(error);
  }
  photoUploadSuccess = (filename) => {
      this.setState({progress: 100, isUploading: false});
      
      storage.images.child(filename).getDownloadURL().then(url => this.addPhoto(url));
  };

  //attachments
  addAttachment(url) {

    var lesson = this.state.lesson;
    if(!lesson.Attachments) {
      lesson.Attachments = [];
    }

    var attachment = { ID: uuidv4(), Name: "New Attachment", Description: "description", URL: url, SortIndex: 0};

    lesson.Attachments.push(attachment);
    lesson.Attachments.sort(compareSortIndex);
    this.setState({lesson:lesson});
  }

  updateAttachment(attachment) {
    var lesson = this.state.lesson;
    
    for(var i = 0; i < lesson.Attachments.length; i++) {
      if(lesson.Attachments[i].ID === attachment.ID) {
        lesson.Attachments[i] = attachment;
        break;
      }
    }
    lesson.Attachments.sort(compareSortIndex);
    this.setState({lesson:lesson});
  }

  deleteAttachment(attachment) {
    var lesson = this.state.lesson;

    for(var i = lesson.Attachments.length - 1; i > -1; i--) {
      if(lesson.Attachments[i].ID === attachment.ID) {
        lesson.Attachments.splice(i,1);
        break;
      }
    }

    this.setState({lesson:lesson});
  }

  attachmentUploadStart = () => this.setState({isUploading: true, progress: 0});
  attachmentUploadProgress = (progress) => this.setState({progress});
  attachmentUploadError = (error) => {
      this.setState({isUploading: false});
      console.error(error);
  }
  attachmentUploadSuccess = (filename) => {
      this.setState({progress: 100, isUploading: false});
      
      storage.attachments.child(filename).getDownloadURL().then(url => this.addAttachment(url));
  };

  getAttachmentCategory(audience) {
    if(audience === 'sink')
      return "Introduce It";
    else if(audience === 'cement')
      return "Cement It";
    else if(audience === 'quick')
      return "Quick Cement";
    else if(audience === 'revisit')
      return "Revisit It";
    else if(audience === 'k1')
      return "K-1";
    else if(audience === '2-3')
      return "2-3";
    else if(audience === '4-5')
      return "4-5";
    else if(audience === '6-8')
      return "6-8";
  }

  trim(value, maxLength) {
    if(value.length > maxLength)
        return value.substring(0,maxLength) + "...";
    else
        return value;
  }

    render() {

      const { classes } = this.props;

      return (
        <div>
          
          <IconButton
            aria-label="Edit"
            onClick={() => this.handleClickOpen("modal")}>
            <Edit className={ classes.tableActionButtonIcon + " " + classes.edit } />
          </IconButton>
          <Dialog
            classes={{
              root: classes.center,
              paper: classes.modal
            }}
            fullScreen
            open={this.state.modal}
            TransitionComponent={Transition}
            keepMounted
            onClose={() => this.handleClose("modal")}
            aria-labelledby="modal-slide-title"
            aria-describedby="modal-slide-description">

            <DialogTitle
              id="classic-modal-slide-title"
              disableTypography
              className={classes.modalHeader}
              style={{backgroundColor:"#efefef"}} >

              <GridContainer direction="row">
                <GridItem xs={12} sm={12} md={6}>
                  <h4 className={classes.modalTitle}>Edit Lesson</h4>
                  <div style={{color:"#696969", fontSize:"13px"}}>Q: <span style={{color:"#3fa31b"}}>{this.state.lesson.Quarter}</span> W: <span style={{color:"#3fa31b"}}>{this.state.lesson.Week}</span> - <span style={{color:"#3fa31b"}}>{this.state.lesson.Name}</span></div>
                </GridItem>
                <GridItem xs={12} sm={12} md={6} style={{textAlign:"right"}}>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={this.state.lesson.IsVisible}
                        onChange={(e) => this.updateLesson("IsVisible", e.target.checked)}
                        classes={{
                          switchBase: classes.switchBase,
                          checked: classes.switchChecked,
                          icon: classes.switchIcon,
                          iconChecked: classes.switchIconChecked,
                          bar: classes.switchBar
                        }}
                      />
                    }
                    classes={{
                      label: classes.label
                    }}
                    label="Visible"
                  />
                  <Button onClick={() => this.handleClose("modal")} >
                    Cancel
                  </Button>
                  &nbsp;
                  <Button
                    onClick={() => {
                        this.saveLesson();
                        this.handleClose("modal");
                      }}
                    color="success">
                    Save
                  </Button>
                </GridItem>
              </GridContainer>
            </DialogTitle>
            <DialogContent
              id="modal-slide-description"
              className={classes.modalBody}
              style={{backgroundColor:"#efefef"}}>

             <CustomTabs
                headerColor="success"
                tabs={[
                  {
                    tabName: "General",
                    tabIcon: Location,
                    tabContent: (
                      
                        <GridContainer direction="row">
                          <GridItem xs={12} sm={12} md={4}>
                            <CustomInput
                              id="name"
                              labelText="Name"
                              value={this.state.lesson.Name}
                              inputProps={{
                                  placeholder: "Name"
                              }}
                              formControlProps={{
                                  fullWidth: true
                              }}
                              onChange={(e) => this.updateLesson("Name", e.target.value)}
                            />
                          </GridItem>
                          <GridItem xs={12} sm={12} md={4}>
                              <CustomSelect
                                id="course"
                                labelText="Course"
                                value={this.state.lesson.Course}
                                inputProps={{
                                    placeholder: "Course"
                                }}
                                formControlProps={{
                                    fullWidth: true
                                }}
                                onChange={(e) => this.updateLesson("Course", e.target.value)}
                                options={this.state.courses}
                               />
                          </GridItem>
                          <GridItem xs={12} sm={12} md={2}>
                              <CustomSelect
                                id="quarter"
                                labelText="Quarter"
                                value={this.state.lesson.Quarter}
                                inputProps={{
                                    placeholder: "Quarter"
                                }}
                                formControlProps={{
                                    fullWidth: true
                                }}
                                onChange={(e) => this.updateLesson("Quarter", e.target.value)}
                                options={[
                                  {key:1,label:"1"},
                                  {key:2,label:"2"},
                                  {key:3,label:"3"},
                                  {key:4,label:"4"}]}
                               />
                          </GridItem>
                          <GridItem xs={12} sm={12} md={2}>
                              <CustomSelect
                                id="week"
                                labelText="Week"
                                value={this.state.lesson.Week}
                                inputProps={{
                                    placeholder: "Week"
                                }}
                                formControlProps={{
                                    fullWidth: true
                                }}
                                onChange={(e) => this.updateLesson("Week", e.target.value)}
                                options={[
                                  {key:1,label:"1"},
                                  {key:2,label:"2"},
                                  {key:3,label:"3"},
                                  {key:4,label:"4"},
                                  {key:5,label:"5"},
                                  {key:6,label:"6"},
                                  {key:7,label:"7"},
                                  {key:8,label:"8"},
                                  {key:9,label:"9"}
                                ]}
                               />
                          </GridItem>
                          <GridItem xs={12} sm={12} md={9}>
                            <CustomInput
                                id="description"
                                labelText="Description"
                                value={this.state.lesson.Description}
                                inputProps={{
                                    placeholder: "Description",
                                    multiline:true
                                }}
                                formControlProps={{
                                    fullWidth: true
                                }}
                                onChange={(e) => this.updateLesson("Description", e.target.value)}
                            />
                          </GridItem>
                          <GridItem xs={12} sm={12} md={3}>
                            <CustomInput
                                labelText="Release Date"
                                value={this.state.lesson.ReleaseDate}
                                inputProps={{
                                    placeholder: "Release Date",
                                    multiline:true
                                }}
                                formControlProps={{
                                    fullWidth: true
                                }}
                                onChange={(e) => this.updateLesson("ReleaseDate", e.target.value)}
                            />
                          </GridItem>
                          <GridItem xs={12} sm={12} md={12}>
                            <CustomInput
                                labelText="Journal Questions"
                                value={this.state.lesson.Questions}
                                inputProps={{
                                    placeholder: "Journal Questions",
                                    multiline:true
                                }}
                                formControlProps={{
                                    fullWidth: true
                                }}
                                onChange={(e) => this.updateLesson("Questions", e.target.value)}
                            />
                          </GridItem>
                          <GridItem xs={12} sm={12} md={9}>
                            <CustomInput
                                labelText="Quote"
                                value={this.state.lesson.Quote}
                                inputProps={{
                                    placeholder: "Quote",
                                    multiline:true
                                }}
                                formControlProps={{
                                    fullWidth: true
                                }}
                                onChange={(e) => this.updateLesson("Quote", e.target.value)}
                            />
                          </GridItem>
                          <GridItem xs={12} sm={12} md={3}>
                            <CustomInput
                                labelText="Attribution"
                                value={this.state.lesson.Attribution}
                                inputProps={{
                                    placeholder: "Quote Attribution",
                                    multiline:true
                                }}
                                formControlProps={{
                                    fullWidth: true
                                }}
                                onChange={(e) => this.updateLesson("Attribution", e.target.value)}
                            />
                          </GridItem>
                        </GridContainer>
                    )
                  },
                  {
                    tabName: "Content",
                    tabIcon: Notes,
                    tabContent: (
                        <GridContainer style={{minHeight:"300px"}}>
                          <GridItem xs={12} sm={12} md={12}>
                            <ContentEditor 
                              value={this.state.lesson.Content}
                              onChange={(e) => this.updateLesson("Content", e)}
                            />
                            </GridItem>
                        </GridContainer>
                      )
                  },
                  {
                    tabName: "Book List",
                    tabIcon: Book,
                    tabContent: (
                        <GridContainer style={{minHeight:"300px"}}>
                          <GridItem xs={12} sm={12} md={12}>
                            <ContentEditor 
                              value={this.state.lesson.BookList}
                              onChange={(e) => this.updateLesson("BookList", e)}
                            />
                            </GridItem>
                        </GridContainer>
                      )
                  },
                  {
                    tabName: "Photos",
                    tabIcon: Photos,
                    tabContent: (

                      <div>
                        <div style={{marginTop:"10px"}}>

                          <label style={{color: "#696969", cursor:"pointer"}}>
                            Upload a New Photo  
                          
                            <FileUploader
                              hidden 
                              accept="image/*"
                              name="photo"
                              randomizeFilename
                              storageRef={storage.images}
                              onUploadStart={this.photoUploadStart}
                              onUploadError={this.photoUploadError}
                              onUploadSuccess={this.photoUploadSuccess}
                              onProgress={this.photoUploadProgress}
                              />
                              
                          </label>
                        </div>

                        <GridContainer justify="flex-start">
                          {this.state.lesson.Photos.map(photo => (
                              <PhotoCard key={photo.ID} photo={photo} 
                                onPhotoUpdated={this.updatePhoto} onPhotoMakeCover={this.makeCoverPhoto} 
                                onPhotoMakeThumb={this.makeThumbPhoto} onPhotoDelete={this.deletePhoto} />
                          ))}
                        </GridContainer>
                      </div>
                    )
                  },
                  {
                    tabName: "Attachments",
                    tabIcon: Attachment,
                    tabContent: (

                      <div>
                        <div style={{marginTop:"10px"}}>

                          <label style={{color: "#696969", cursor:"pointer"}}>
                            Upload a New File  
                          
                            <FileUploader
                              hidden 
                              name="attachment"
                              randomizeFilename
                              storageRef={storage.attachments}
                              onUploadStart={this.attachmentUploadStart}
                              onUploadError={this.attachmentUploadError}
                              onUploadSuccess={this.attachmentUploadSuccess}
                              onProgress={this.attachmentUploadProgress}
                              />
                              
                          </label>
                        </div>

                        <Table className={classes.table}>
                          <TableHead>
                            <TableRow>
                              <TableCell>

                              </TableCell>
                              <TableCell>
                                Name
                              </TableCell>
                              <TableCell>
                                Audience
                              </TableCell>
                              <TableCell>
                                Category
                              </TableCell>
                              <TableCell>
                                Sort Index
                              </TableCell>
                              <TableCell>
                                
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {this.state.lesson.Attachments.map((attachment,index) => (
                            <TableRow key={index} className={classes.tableRow}>
                              <TableCell className={classes.tableActions}>
                                <Tooltip id="tooltip-top" title="Edit Attachment" placement="top" classes={{ tooltip: classes.tooltip }} >
                                  <AttachmentEditor key={attachment.ID} attachment={attachment} 
                                    onAttachmentUpdated={this.updateAttachment} />
                                </Tooltip>
                              </TableCell>
                              <TableCell className={classes.tableCell}>
                                {attachment.Name}
                              </TableCell>
                              <TableCell className={classes.tableCell}>
                                {attachment.Audience}
                              </TableCell>
                              <TableCell className={classes.tableCell}>
                                {this.getAttachmentCategory(attachment.Category)}
                              </TableCell>
                              <TableCell className={classes.tableCell}>
                                {attachment.SortIndex}
                              </TableCell>
                              <TableCell className={classes.tableCell}>
                                <Tooltip id="tooltip-top" title="Delete Attachment" placement="top" classes={{ tooltip: classes.tooltip }} >
                                  <IconButton onClick={() => this.deleteAttachment(attachment)}>
                                    <Delete />
                                  </IconButton>
                                </Tooltip>
                              </TableCell>
                            </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                        
                      </div>
                    )
                  }
                ]}
              />

            </DialogContent>
            
            <DialogActions
              className={classes.modalFooter }
              style={{backgroundColor:"#efefef"}}>
              
            </DialogActions>
          </Dialog>
        </div>
      );
    }
  }
  
const mapStateToProps = state => {
  return state;
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({onLessonCreated: LessonCreated }, dispatch);  
}

LessonEditor = connect(mapStateToProps, mapDispatchToProps)(LessonEditor);
export default withStyles(modalStyle)(LessonEditor);


// WEBPACK FOOTER //
// ./src/components/LessonEditor/LessonEditor.jsx